import {Accordion, AccordionDetails, AccordionSummary, Card, Grid} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {SwitchSegmentedYesNo} from '../../../Core/UI';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {SelectInputElement} from '../Components/SelectInputElement';
import React from 'react';
import {observer} from 'mobx-react-lite';
import {HealthQuestionsProps} from './HealthQuestionsList';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/HealthXref';

const SleepApnea = observer(({counter, valueChanged, parameters, coreQuestions}: HealthQuestionsProps) => {
    return (
        <Accordion style={{width: '100%'}} TransitionProps={{unmountOnExit: true}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={'sleepApnea-content'}
                id={'sleepApnea-header'}
            >
                <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                    <div>Sleep apnea</div>
                    <div>{counter('sleepApnea')}</div>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container>
                    <Grid key="params" container>
                        {coreQuestions?.map(({name, label}) => (
                            <Grid item xs={4} key={name}>
                                <SwitchSegmentedYesNo
                                    param={{
                                        name: name,
                                        label: label,
                                        category: 'sleepApnea',
                                        ...(parameters[name as keyof typeof parameters] as Parameter),
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                />
                            </Grid>
                        ))}
                        {parameters.SleepApnea.value && (
                            <Grid item xs={12} style={{marginTop: 10}}>
                                <Card style={{padding: 20}}>
                                    <strong>Sleep Apnea</strong>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker
                                                    inputVariant="outlined"
                                                    variant="inline"
                                                    openTo="year"
                                                    views={['year', 'month']}
                                                    label="When were you diagnosed?"
                                                    style={{width: '100%', marginTop: 8}}
                                                    value={parameters.sleepapneaDiagnosisDate?.value || null}
                                                    onChange={(date) =>
                                                        valueChanged(parameters.sleepapneaDiagnosisDate, date)
                                                    }
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SelectInputElement
                                                param={{
                                                    label: 'Is your sleep apnea',
                                                    name: 'sleepapneaSeverity',
                                                    options: fieldOptions.sleepapneaSeverity.options,
                                                    ...parameters.sleepapneaSeverity,
                                                }}
                                                required={''}
                                                valueChanged={valueChanged}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SwitchSegmentedYesNo
                                                param={{
                                                    name: 'sleepapneaTreatment',
                                                    label: 'Are you currently complying with use of a CPAP, mouthguard or other prescribed treatment to treat this condition?',
                                                    ...parameters.sleepapneaTreatment,
                                                }}
                                                required={''}
                                                valueChanged={valueChanged}
                                            />
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
});

export default SleepApnea;
